export const surpriseTh = {
    btn_draw: 'ลุ้นรางวัล',
    confirm: {
        title: 'ยืนยันการเปิดถุง',
        msg: 'คุณต้องการใช้ {0}<br>ในการเปิดถุงหรือไม่?',
        msg_point: 'คะแนน',
        point_not_enough: 'คะแนนของคุณไม่เพียงพอ',
        btn_confirm: 'ยืนยัน',
        btn_cancel: 'ยกเลิก',
    },
    free: 'รับฟรี!',
    point_unit: 'คะแนน',
    pre_point_msg: 'ยินดีด้วย คุณได้รับแต้ม<br>จำนวน {0} คะแนน',
    lose: 'ขออภัยค่ะ ท่านยังไม่ใช่ผู้โชคดี<br>มาร่วมกิจกรรมอีกครั้งวันพรุ่งนี้นะคะ',
    btn_close: 'ปิด',
    btn_history: 'ดูประวัติ',
    btn_success_confirm: 'ยืนยัน',
    btn_success_cancel: 'ยกเลิก',
    delivery_success: {
        title: 'รับสิทธิ์เรียบร้อยแล้ว',
        msg: 'บริษัทจะจัดส่งของรางวัลให้<br>ภายใน 14 วันทำการ',
        btn_cancel: 'ปิด',
        btn_ok: 'ดูประวัติ',
    },
    msg_free_delivery: 'ยินดีด้วย คุณได้รับ<br/>',
    msg_err: 'วันนี้คุณใช้สิทธิ์แล้ว<br/>พรุ่งนี้กลับมาลุ้นใหม่อีกครั้งนะคะ',
    msg_full: 'ขออภัยค่ะ ของรางวัลหมดแล้ว<br/>พบกันใหม่กิจกรรมหน้า<br/>ขอบคุณที่ร่วมสนุก',
    notfound: 'ไม่พบข้อมูล',
    err_500: 'พบปัญหาการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง',
    btn_diabled: {
        interval: 'วันนี้คุณใช้สิทธิ์แล้ว',
        expire_date: 'หมดเขตการเข้าร่วมกิจกรรม',
        full_quota: 'ขออภัย สิทธิ์เต็มจำนวนแล้ว',
        point_not_enough: 'คะแนนของคุณไม่เพียงพอ'
    }
}
